<template>
    <div class="shop__filter-drawer">
        <img class="shop__filter-drawer__chevron" @click="$emit('toggle')" src="@/assets/images/decoration/arrow-shop.svg"/>
        <filters
            :title="$t('FILTER_TITLE')"
            :categories="categories"
            @input="filterProducts"
            :dividers="true"/>
        <button class="btn btn--primary text-shadow--none" @click="$emit('toggle')" type="button" name="button">View products</button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Filters from '@/components/partials/account/shop/Filters';

export default {
    name: 'FilterDrawer',
    components: { Filters },
    computed: {
        ...mapGetters({
            categories: 'shop/getCategories',
        }),
    },
    methods: {
        filterProducts(filter) {
            this.$emit('input', filter);
        },
    },
};
</script>
